import Axios from 'axios'
import qs from 'qs'
// let url = 'http://api.cz.365mooc.cn/';
let url = 'http://api.zhxy.czvtc.edu.cn/';
// 获取专题列表
export function getTopics(module) {
  const data = {
    m:'artApi',
    t: "topic",
    c: "getTopics",
    sch_id: module.sch_id,
  };
  return Axios(url, { params: data }).then(res => {
    return Promise.resolve(res.data)
  })
}
// 获取专题列表结束


// 获取单个专题详情
export function getTopic(module) {
  const data = {
    m:'artApi',
    t: "topic",
    c: "getTopic",
    sch_id: module.sch_id,
    topic_id: module.topic_id,
  };
  return Axios(url, { params: data }).then(res => {
    return Promise.resolve(res.data)
  })
}
// 获取单个专题详情结束

// 获取专题下栏目列表
export function getArtCates(module) {
  const data = {
    m:'artApi',
    t: "artCate",
    c: "getArtCates",
    sch_id: module.sch_id,
    topic_id: module.topic_id,
  };
  return Axios(url, { params: data }).then(res => {
    return Promise.resolve(res.data)
  })
}
// 获取专题下栏目列表结束

// 获取栏目详情
export function getArtCate(module) {
  const data = {
    m:'artApi',
    t: "artCate",
    c: "getArtCate",
    sch_id: module.sch_id,
    cate_id: module.cate_id,
  };
  return Axios(url, { params: data }).then(res => {
    return Promise.resolve(res.data)
  })
}
// 获取栏目详情结束

// 获取栏目下文章列表
export function getArticles(module) {
  const data = {
    m:'artApi',
    t: "art",
    c: "getArticles",
    sch_id: module.sch_id,
    cate_id: module.cate_id,
    page: module.page,
    pagesize: module.pagesize,
  };
  return Axios(url, { params: data }).then(res => {
    return Promise.resolve(res.data)
  })
}
// 获取栏目下文章列表结束

// 获取栏目下文章详情
export function getArticle(module) {
  const data = {
    m:'artApi',
    t: "art",
    c: "getArticle",
    sch_id: module.sch_id,
    art_id: module.art_id,
  };
  return Axios(url, { params: data }).then(res => {
    return Promise.resolve(res.data)
  })
}
// 获取栏目下文章详情结束


//更新文章阅读数 post
export function updateSee(module) {
  const data = qs.stringify({
    m: 'artApi',
    t: 'art',
    c: 'updateSee',
    sch_id: module.sch_id,
    art_id: module.art_id,
    keyword: module.keyword,
    search_type: module.search_type,
  });
  return Axios.post(url, data).then(res => {
    return Promise.resolve(res.data)
  })
}

//更新文章阅读数结束 get
export function getArticlesForSearch(module) {
  const data = {
    m:'artApi',
    t: "art",
    c: "getArticlesForSearch",
    sch_id: module.sch_id,
    topic_id: module.topic_id,
    keyword: module.keyword,
    search_type: module.search_type,
    page: module.page,
    pagesize: module.pagesize,
  };
  return Axios(url, { params: data }).then(res => {
    return Promise.resolve(res.data)
  })
}



// WEBPACK FOOTER //
// ./src/api/api.js